module.exports = __webpack_public_path__ + "img/xls.682a5c3e.png";